@import '../../../constants/spacing.module.less';

.section-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: @space-24;
  background-color: var(--grey-100);
  border: 1px dashed var(--grey-400);
  border-radius: 4px;
  text-align: center;
  gap: @space-8;
}
